import { Modal, Space, Table, Tooltip, Input, Popconfirm, Select, Button, Divider } from "antd";
import React from "react";
import { withRouter } from "../../components/withRouter";
import Header from "../../components/Header";
import {
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { openNotification } from "../../functions";
var moment = require("moment");

const { Option } = Select;

class Sales extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalRole: false,
      clientName: "",
      selectedRole: "1",
      saleModal: false,

      partners: [],
      products: [],
      clients: [],
      selectedClient: "",
      activePromo: "",
      searchProductModal: false,
      searchProdKey: 0,
      searchProdValue: {},
      salesPoints: [],
      sale_products: [
        {
          name: "",
          price: "",
          count: 1,
        },
      ],

      saleSelectSalePoint: 0,

      sales: [],

      selectedCustomer: 0,
      selectedCustomerName: "",
      selectedCustomerPrice: 0,
      selectedCustomerPriceDeleted: 0,
      selectedProvider: 0,
      selectedProviderPrice: 0,
      selectedProviderPriceDeleted: 0,
      selectedProviderName: "",
      selectedPartner: 0,
      selectedPartnerName: "",
      selectedPartnerPrice: 0,
      selectedPartnerPriceDeleted: 0,
      selectedSalePrice: 0,
      selectedPromo: "",
    };
  }

  ChangeInputValue = (e) => {
    let name = e.target.name;
    let value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [name]: value });
  };

  getProducts() {
    fetch(`https://bot.weddingchelny.ru/api/adm/products`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "GET",
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({ products: res.data });
        }
      }
    });
  }

  getPartners() {
    fetch(`https://bot.weddingchelny.ru/api/adm/partners`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "GET",
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({ partners: res.data });
        }
      }
    });
  }

  getClients() {
    fetch(`https://bot.weddingchelny.ru/api/adm/clients`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "GET",
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({ clients: res.data });
        }
      }
    });
  }

  addProductOnSale() {
    var sale_products = this.state.sale_products;
    sale_products.push({
      name: "",
      price: "",
      count: 1,
    });
    this.setState({ sale_products });
  }

  deleteProductOnSale(index) {
    var sale_products = this.state.sale_products;
    sale_products.splice(index, 1);
    this.setState({ sale_products });
  }

  newSale() {
    this.getPartners();
    this.getClients();
    this.getPoints();
    this.setState({ saleModal: true });
  }

  onMIChange = (key, e) => {
    let name = e.target.name;
    let val = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    let sale_products = this.state.sale_products;
    sale_products[key][name] = val;
    this.setState({ sale_products });
  };

  ChangeInputPrice = (e) => {
    let regex = /^(0|[1-9][0-9]*)(\.[0-9]{0,2})?$/;
    let name = e.target.name;
    let value = e.target.type === "checkbox" ? e.target.checked : e.target.value;

    if (regex.test(value) || value == "") {
      this.setState({ [name]: value });
    }
  };

  searchProduct(index) {
    this.getProducts();
    this.setState({ searchProductModal: true, searchProdKey: index });
  }

  setSelectedProd(elem) {
    let sale_products = this.state.sale_products;
    sale_products[this.state.searchProdKey].name = elem.p_name;
    sale_products[this.state.searchProdKey].price = elem.p_price;
    this.setState({ sale_products, searchProductModal: false, searchProdKey: 0 });
  }

  checkPromo() {
    fetch(`https://bot.weddingchelny.ru/api/adm/sale/checkpromo`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "post",
      body: JSON.stringify({
        promo: this.state.activePromo,
        client: this.state.selectedClient,
      }),
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.pushSale();
        }
      }
    });
  }

  pushSale() {
    fetch(`https://bot.weddingchelny.ru/api/adm/sale/`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "post",
      body: JSON.stringify({
        promo: this.state.activePromo,
        client: this.state.selectedClient,
        products: this.state.sale_products,
        selectPoint: this.state.saleSelectSalePoint,
      }),
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          openNotification("Успех", res.data, 3, 3.0);
          this.setState({
            modalRole: false,
            clientName: "",
            selectedRole: "1",
            saleModal: false,
            saleSelectSalePoint: "0",

            partners: [],
            products: [],
            clients: [],
            selectedClient: "",
            activePromo: "",
            searchProductModal: false,
            searchProdKey: 0,
            searchProdValue: {},

            sale_products: [
              {
                name: "",
                price: "",
                count: 1,
              },
            ],
          });
          this.getSales();
        }
      }
    });
  }

  getSales() {
    fetch(`https://bot.weddingchelny.ru/api/adm/sales/all`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "get",
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({ sales: res.data });
        }
      }
    });
  }

  getPoints() {
    fetch(`https://bot.weddingchelny.ru/api/adm/sales-points`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "GET",
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({ salesPoints: res.data });
        }
      }
    });
  }

  postBalans() {
    fetch(`https://bot.weddingchelny.ru/api/adm/sales/balans`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "POST",
      body: JSON.stringify({
        partner_id: this.state.selectedPartner,
        partner_price: this.state.selectedPartnerPrice,
        customer_id: this.state.selectedCustomer,
        customer_price: this.state.selectedCustomerPrice,
        provider: this.state.selectedProvider,
        provider_price: this.state.selectedProviderPrice,
        provider_price_deleted: this.state.selectedProviderPriceDeleted,
        customer_price_deleted: this.state.selectedCustomerPriceDeleted,
        partner_price_deleted: this.state.selectedPartnerPriceDeleted,
        sale_id: this.state.selectedSaleId,
      }),
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          openNotification("Успех", "Сохранено", 3, 3.0);
          this.getSales();
          this.setState({
            modalRole: false,
            clientName: "",
            selectedRole: "1",
            saleModal: false,

            partners: [],
            products: [],
            clients: [],
            selectedClient: "",
            activePromo: "",
            searchProductModal: false,
            searchProdKey: 0,
            searchProdValue: {},
            salesPoints: [],
            sale_products: [
              {
                name: "",
                price: "",
                count: 1,
              },
            ],

            saleSelectSalePoint: 0,

            sales: [],

            selectedCustomer: 0,
            selectedCustomerName: "",
            selectedCustomerPrice: 0,
            selectedCustomerPriceDeleted: 0,
            selectedProvider: 0,
            selectedProviderPrice: 0,
            selectedProviderPriceDeleted: 0,
            selectedProviderName: "",
            selectedPartner: 0,
            selectedPartnerName: "",
            selectedPartnerPrice: 0,
            selectedPartnerPriceDeleted: 0,
            selectedSalePrice: 0,
            selectedPromo: "",
          });
        }
      }
    });
  }

  render() {
    const columns = [
      {
        title: "№ продажи",
        dataIndex: "sale_id",
        key: "sale_id",
      },
      {
        title: "Дата и время",
        dataIndex: "sale_date",
        key: "sale_date",
        render: (text, record) => {
          return moment(record.sale_date).format("DD.MM.YYYY HH:mm");
        },
      },
      {
        title: "Продавец",
        dataIndex: "saler",
        key: "saler",
        render: (text, record) => {
          return record.saler_surname + " " + record.saler_name;
        },
      },
      {
        title: "Имя клиента",
        dataIndex: "customer_name",
        key: "customer_name",
      },
      {
        title: "Никнейм Telegram",
        dataIndex: "customer_username",
        key: "customer_username",
      },
      {
        title: "Товары",
        dataIndex: "products",
        key: "products",
        render: (text, record) => {
          let str = "";
          record.products.map((elem, index) => {
            str +=
              elem.name + " X " + elem.count + " = " + Number.parseFloat(elem.price * elem.count).toFixed(2) + "; ";
          });
          return str;
        },
      },
      {
        title: "Сумма",
        dataIndex: "full_price",
        key: "full_price",
      },
      {
        title: "Действия",
        dataIndex: "events",
        key: "events",
        render: (text, record) => {
          if (record.need_add == 1) {
            return (
              <Tooltip title="Зачислить баллы">
                <EditOutlined
                  onClick={() => {
                    this.setState({
                      selectedCustomer: record.customer_id,
                      selectedCustomerName: record.customer_username + "|" + record.customer_name,
                      selectedCustomerPrice: 0,
                      selectedPartner: record.partner_id,
                      selectedPartnerName: record.partner_username + "|" + record.partner_name,
                      selectedProviderName: record.provider_username + "|" + record.provider_name,
                      selectedProviderPrice: 0,
                      selectedPartnerPrice: 0,
                      selectedSalePrice: record.full_price,
                      selectedSaleId: record.sale_id,
                      selectedPromo: record.promo_content,
                      saleModal: true,
                    });
                  }}
                />
              </Tooltip>
            );
          } else {
            return "Баланс распределен";
          }
        },
      },
    ];

    return (
      <div>
        <Header />
        <div className="container">
          <Space>
            <h1>Продажи</h1>
            {/* <Button type='primary' onClick={() => { this.newSale();  }}>Новая продажа</Button> */}
          </Space>
          {window.innerWidth > 650 ? (
            <Table columns={columns} dataSource={this.state.sales} />
          ) : (
            this.state.sales.map((record) => {
              let str = "";
              record.products.map((elem, index) => {
                str +=
                  elem.name + " X " + elem.count + " = " + Number.parseFloat(elem.price * elem.count).toFixed(2) + "; ";
              });
              return (
                <div className="sale_item">
                  <div>№ продажи: {record.sale_id}</div>
                  <div>Дата и время: {moment(record.sale_date).format("DD.MM.YYYY HH:mm")}</div>
                  <div>Продавец: {record.saler}</div>
                  <div>Имя клиента: {record.customer_name}</div>
                  <div>Никнейм Telegram: {record.customer_username}</div>
                  <div>Товары: {str}</div>
                  <div>Сумма: {record.full_price}</div>
                  <div>
                    Действия:{" "}
                    {record.need_add == 1 ? (
                      <button
                        onClick={() => {
                          this.setState({
                            selectedCustomer: record.customer_id,
                            selectedCustomerName: record.customer_username + "|" + record.customer_name,
                            selectedCustomerPrice: 0,
                            selectedPartner: record.partner_id,
                            selectedPartnerName: record.partner_username + "|" + record.partner_name,
                            selectedProviderName: record.provider_username + "|" + record.provider_name,
                            selectedProviderPrice: 0,
                            selectedPartnerPrice: 0,
                            selectedSalePrice: record.full_price,
                            selectedSaleId: record.sale_id,
                            selectedPromo: record.promo_content,
                            saleModal: true,
                          });
                        }}
                      >
                        <EditOutlined /> Зачислить баллы
                      </button>
                    ) : (
                      "Баланс распределен"
                    )}
                  </div>
                </div>
              );
            })
          )}

          <Modal
            style={{ maxWidth: "1200px" }}
            title={"Распределение баланса"}
            width={"100%"}
            open={this.state.saleModal}
            onOk={() => {
              this.postBalans();
            }}
            onCancel={() => {
              this.setState({ saleModal: false });
            }}
            okText="Сохранить"
            cancelText="Отмена"
          >
            Сумма покупки = {this.state.selectedSalePrice} <br />
            Промокод - {this.state.selectedPromo}
            {window.innerWidth > 650 ? (
              <div>
                <Space direction="horizontal" style={{ width: "100%" }} justify="space-between">
                  <div>
                    <Divider orientation="left">Клиент</Divider>
                    {this.state.selectedCustomerName}
                    <div>Сумма пополнения баланса</div>
                    <Input
                      type="number"
                      name="selectedCustomerPrice"
                      min="1"
                      onChange={(e) => {
                        this.ChangeInputPrice(e);
                      }}
                      value={this.state.selectedCustomerPrice}
                    />
                  </div>
                  <div>
                    <Divider orientation="left">Партнер (чей промокод)</Divider>
                    {this.state.selectedPartnerName}
                    <div>Сумма пополнения баланса</div>
                    <Input
                      type="number"
                      name="selectedPartnerPrice"
                      min="1"
                      onChange={(e) => {
                        this.ChangeInputPrice(e);
                      }}
                      value={this.state.selectedPartnerPrice}
                    />
                  </div>
                  <div>
                    <Divider orientation="left">Привел клиента</Divider>
                    {this.state.selectedProviderName}
                    <div>Сумма пополнения баланса</div>
                    <Input
                      type="number"
                      name="selectedProviderPrice"
                      min="1"
                      onChange={(e) => {
                        this.ChangeInputPrice(e);
                      }}
                      value={this.state.selectedProviderPrice}
                    />
                  </div>
                </Space>
                <Space direction="horizontal" style={{ width: "100%" }} justify="space-between">
                  <div>
                    <div>Пополнение сгораемого баланса</div>
                    <Input
                      type="number"
                      name="selectedCustomerPriceDeleted"
                      min="1"
                      onChange={(e) => {
                        this.ChangeInputPrice(e);
                      }}
                      value={this.state.selectedCustomerPriceDeleted}
                    />
                  </div>
                  <div>
                    <div>Пополнение сгораемого баланса</div>
                    <Input
                      type="number"
                      name="selectedPartnerPriceDeleted"
                      min="1"
                      onChange={(e) => {
                        this.ChangeInputPrice(e);
                      }}
                      value={this.state.selectedPartnerPriceDeleted}
                    />
                  </div>
                  <div>
                    <div>Пополнение сгораемого баланса</div>
                    <Input
                      type="number"
                      name="selectedProviderPriceDeleted"
                      min="1"
                      onChange={(e) => {
                        this.ChangeInputPrice(e);
                      }}
                      value={this.state.selectedProviderPriceDeleted}
                    />
                  </div>
                </Space>
              </div>
            ) : (
              <div>
                <Space direction="vertical" style={{ width: "100%" }} justify="space-between">
                  <div>
                    <Divider orientation="left">Клиент</Divider>
                    {this.state.selectedCustomerName}
                    <div>Сумма пополнения баланса</div>
                    <Input
                      type="number"
                      name="selectedCustomerPrice"
                      min="1"
                      onChange={(e) => {
                        this.ChangeInputPrice(e);
                      }}
                      value={this.state.selectedCustomerPrice}
                    />
                    <div>
                      <div>Пополнение сгораемого баланса</div>
                      <Input
                        type="number"
                        name="selectedCustomerPriceDeleted"
                        min="1"
                        onChange={(e) => {
                          this.ChangeInputPrice(e);
                        }}
                        value={this.state.selectedCustomerPriceDeleted}
                      />
                    </div>
                  </div>
                  <div>
                    <Divider orientation="left">Партнер (чей промокод)</Divider>
                    {this.state.selectedPartnerName}
                    <div>Сумма пополнения баланса</div>
                    <Input
                      type="number"
                      name="selectedPartnerPrice"
                      min="1"
                      onChange={(e) => {
                        this.ChangeInputPrice(e);
                      }}
                      value={this.state.selectedPartnerPrice}
                    />
                    <div>
                      <div>Пополнение сгораемого баланса</div>
                      <Input
                        type="number"
                        name="selectedPartnerPriceDeleted"
                        min="1"
                        onChange={(e) => {
                          this.ChangeInputPrice(e);
                        }}
                        value={this.state.selectedPartnerPriceDeleted}
                      />
                    </div>
                  </div>
                  <div>
                    <Divider orientation="left">Привел клиента</Divider>
                    {this.state.selectedProviderName}
                    <div>Сумма пополнения баланса</div>
                    <Input
                      type="number"
                      name="selectedProviderPrice"
                      min="1"
                      onChange={(e) => {
                        this.ChangeInputPrice(e);
                      }}
                      value={this.state.selectedProviderPrice}
                    />
                    <div>
                      <div>Пополнение сгораемого баланса</div>
                      <Input
                        type="number"
                        name="selectedProviderPriceDeleted"
                        min="1"
                        onChange={(e) => {
                          this.ChangeInputPrice(e);
                        }}
                        value={this.state.selectedProviderPriceDeleted}
                      />
                    </div>
                  </div>
                </Space>
              </div>
            )}
          </Modal>
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.getSales();
  }
}

export default withRouter(Sales);
